import SaveIcon from '@mui/icons-material/Save';
import { Chip, FormLabel, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const Objetivo = () => {
    const { setPromptData } = useActividadesContext();


    const opciones = ['Invitar', 'Coordinar', 'Informar', 'Solicitar', 'Compartir'];
    const [objetivo, setObjetivo] = useState('');
    const [esEditable, setEsEditable] = useState(false);
    const [textoPersonalizado, setTextoPersonalizado] = useState('Otro');

    const handleObjetivoClick = (opcion) => {
        setObjetivo(opcion);
        setPromptData((prevData) => ({ ...prevData, objetivo: opcion }));
    };

    const activarEdicion = () => {
        setEsEditable(true);
    };

    const handleCambioTexto = (event) => {
        setTextoPersonalizado(event.target.value);
    };

    const guardarCambio = () => {
        setEsEditable(false);
        setObjetivo(textoPersonalizado);
        setPromptData((prevData) => ({ ...prevData, objetivo: textoPersonalizado }));
    };

    return (
        <Grid item xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                Objetivo *
            </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>
                Selecciona el objetivo del mensaje
            </FormLabel>
            <Grid container spacing={1}>
                <Grid item display={'flex'} flexDirection={'row'}>
                    {opciones.map((opcion) => (
                        <Grid item key={opcion}>
                            <Stack direction="row" spacing={5} sx={{ m: 1 }}>
                                <Chip
                                    label={opcion}
                                    onClick={() => handleObjetivoClick(opcion)}
                                    variant="outlined"
                                    sx={{
                                        width: 100,
                                        m: 3,
                                        fontFamily: 'montserrat',
                                        backgroundColor: objetivo === opcion ? '#336B87' : '#FFFFFF',
                                        color: objetivo === opcion ? '#FFFFFF' : '#209099',
                                        borderColor: objetivo === opcion ? 'transparent' : '#336B87',
                                        borderWidth: '2px',
                                        ':hover': {
                                            backgroundColor: objetivo === opcion ? '#1e7888' : '#f5f5f5',
                                            borderColor: '#209099',
                                            color: '#209099'
                                        }
                                    }}
                                />
                            </Stack>
                        </Grid>
                    ))}
                </Grid>
                <Grid item display={'flex'} flexDirection={'row'} xs={12} sm={12} md={6} lg={4} xl={3}>
                    {esEditable ? (
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={textoPersonalizado}
                            onChange={handleCambioTexto}
                            onBlur={guardarCambio}
                            InputProps={{
                                sx: {
                                    borderRadius: 2,
                                    mb: 1,
                                    fontFamily: 'montserrat',
                                    fontSize: '14px',
                                    color: '#336B87',
                                    '&::placeholder': {
                                        color: '#336B87',
                                    },
                                    '&:before': {
                                        borderBottomColor: '#Divider',
                                    },
                                    '&:after': {
                                        borderBottomColor: '#Divider',
                                    },
                                },
                                endAdornment: (
                                    <IconButton onClick={guardarCambio}>
                                        <SaveIcon />
                                    </IconButton>
                                ),
                            }}
                            autoFocus
                        />
                    ) : (
                        <Stack direction="row" spacing={2} sx={{ m: 1, ml: 0 }}>
                            <Chip
                                label={objetivo === textoPersonalizado ? textoPersonalizado : 'Otro'}
                                onClick={activarEdicion}
                                variant="outlined"
                                sx={{
                                    width: 100,
                                    m: 3,
                                    backgroundColor: objetivo === textoPersonalizado ? '#336B87' : '#FFFFFF',
                                    color: objetivo === textoPersonalizado ? '#FFFFFF' : '#209099',
                                    borderColor: objetivo === textoPersonalizado ? 'transparent' : '#336B87',
                                    borderWidth: '2px',
                                    ':hover': {
                                        backgroundColor: objetivo === textoPersonalizado ? '#1e7888' : '#f5f5f5',
                                        borderColor: '#209099',
                                        color: '#209099',
                                    },
                                    fontFamily: 'montserrat',
                                    transition: 'background-color 0.3s ease' // Agregar una transición para suavizar el cambio de color
                                }}
                            />
                        </Stack>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Objetivo;
